import React, { useState } from 'react';
import { Modal } from '../../components/ui';
import { errMsg } from '../../utils/format';
import api from '../../utils/api';

export default function AddProductModal({ onClose, onSaved }) {
  const [form, setForm] = useState({ sku:'', name:'', unitCost:'0', unitPrice:'0', quantityOnHand:'0', quantityAtAmazon:'0', amazonAsin:'', notes:'' });
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      await api.post('/api/products', form);
      onSaved('Product added successfully'); onClose();
    } catch(err) { alert(errMsg(err)); }
    finally { setSaving(false); }
  };

  const set = (k,v) => setForm(f => ({...f, [k]:v}));

  return (
    <Modal title="Add Finished Good" onClose={onClose}
      footer={<><button className="btn" onClick={onClose}>Cancel</button><button className="btn btn-primary" form="add-product-form" type="submit">{saving?'Saving…':'Add SKU'}</button></>}>
      <form id="add-product-form" onSubmit={save}>
        <div className="form-row">
          <div className="form-group"><label>SKU *</label><input required value={form.sku} onChange={e=>set('sku',e.target.value)} placeholder="e.g. SF-ROD-001" /></div>
          <div className="form-group"><label>Product name *</label><input required value={form.name} onChange={e=>set('name',e.target.value)} /></div>
        </div>
        <div className="form-row">
          <div className="form-group"><label>Unit cost ($)</label><input type="number" step="0.0001" min="0" value={form.unitCost} onChange={e=>set('unitCost',e.target.value)} /></div>
          <div className="form-group"><label>Unit price ($)</label><input type="number" step="0.0001" min="0" value={form.unitPrice} onChange={e=>set('unitPrice',e.target.value)} /></div>
        </div>
        <div className="form-row">
          <div className="form-group"><label>Warehouse qty</label><input type="number" min="0" value={form.quantityOnHand} onChange={e=>set('quantityOnHand',e.target.value)} /></div>
          <div className="form-group"><label>Amazon FBA qty</label><input type="number" min="0" value={form.quantityAtAmazon} onChange={e=>set('quantityAtAmazon',e.target.value)} /></div>
        </div>
        <div className="form-group"><label>Amazon ASIN</label><input value={form.amazonAsin} onChange={e=>set('amazonAsin',e.target.value)} placeholder="B0XXXXXXXXX" /></div>
        <div className="form-group"><label>Notes</label><textarea value={form.notes} onChange={e=>set('notes',e.target.value)} /></div>
      </form>
    </Modal>
  );
}
